<card-expanding
  [valid]="productValidity.getCardStatusValidType(cardSection)"
  [expanded]="isExpanded"
  (onExpand)="saveLocalExpandedValue($event)"
>
  <span header-title>
    {{title | translate}}
  </span>


  <div header-actions *ngIf="productCard.isOwnProduct">
    <ng-container *requiredRights="[UserAction.ManageProducts]">
      <lxm-button
        type="beige"
        icon="plus-dark"
        label="cards.products.product_status.action.add_schema"
        (click)="openBaseSchemaDialog()"
      >
      </lxm-button>
    </ng-container>
  </div>

  <div body>
    <div *ngIf="!assortments?.length">
      <no-content
        image="no-product-catalog"
        text="global.no_product_catalog"
        [inline]="true"
      ></no-content>
    </div>

    <div class="row overflow-x" *ngIf="assortments?.length">
      <div class="col-12 no-padding">
        <mat-table
          [dataSource]="assortments"
          matSort
          [@.disabled]="true"
          [class.market-product]="!isOwnProduct"
        >
          <!-- User Column -->
          <ng-container matColumnDef="assortment_base_user">
            <mat-header-cell
              *matHeaderCellDef
              [innerHTML]="'cards.products.product_status.table.user' | translate"
            >
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <user [name]="row.modifiedBy"></user>
            </mat-cell>
          </ng-container>

          <!-- Validity Column -->
          <ng-container matColumnDef="assortment_base_valid">
            <mat-header-cell
              *matHeaderCellDef
              [innerHTML]="'cards.products.product_status.table.valid' | translate"
            >
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span
                >{{row.validFrom | formDate}} - {{row.validTo | formDate}}</span
              >
            </mat-cell>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="assortment_base_status">
            <mat-header-cell
              *matHeaderCellDef
              [innerHTML]="'cards.products.product_status.table.status' | translate"
            >
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <status-circle class="mr5" [status]="row.status"></status-circle>
              <span
                >{{row.status | translateEnum: 'SupplierProductAssortmentStatus'
                }}</span
              >
            </mat-cell>
          </ng-container>

          <!-- Delivery Status Column -->
          <ng-container matColumnDef="assortment_base_delivery_status">
            <mat-header-cell
              *matHeaderCellDef
              [innerHTML]="'cards.products.product_assortment_management.table.delivery_status' | translate"
            >
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span>{{ row.deliveryStatus | translateEnum: 'SupplierProductAssortmentDeliveryStatus' }}</span>
            </mat-cell>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="list_actions">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <lxm-button
                *ngIf="row.isCurrent"
                type="grey"
                icon="mark-as-expired"
                [title]="'cards.products.product_assortment_management_edit.title' | translate"
                (click)="openDeliveryStatusDialog(row)"
              ></lxm-button>
            </mat-cell>
          </ng-container>

          <!-- Visibility -->
          <ng-container matColumnDef="assortment_base_visibility">
            <mat-header-cell *matHeaderCellDef>
              <div
                class="w-full"
                [innerHTML]="'cards.products.product_status.table.visibility' | translate"
              ></div>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" [ngSwitch]="row.retailersListIsExclusive">

              <div class="flex flex-col">

                <ng-container *ngSwitchCase="false">
                  {{ 'common.to_nobody' | translate }}
                  <ng-container *ngIf="row.retailerIds?.length">
                    {{ 'common.except_selected_clients_suffix' | translate }}: <br>
                    <div class="comma-delimited-list">
                      <span *ngFor="let retailerId of row.retailerIds">
                        {{ retailChainsById[retailerId]?.name }}
                      </span>
                    </div>
                  </ng-container>

                </ng-container>

                <ng-container *ngSwitchCase="true">
                  {{ 'common.to_everyone' | translate }}
                  <ng-container *ngIf="row.retailerIds?.length">
                    {{ 'common.except_selected_clients_suffix' | translate }}: <br>
                    <div class="comma-delimited-list">
                      <span *ngFor="let retailerId of row.retailerIds">
                        {{ retailChainsById[retailerId]?.name }}
                      </span>
                    </div>
                  </ng-container>
                </ng-container>
              </div>

              <!-- <div class="triple-rows">
                <div class="cell-row">
                  {{ row.retailersListIsExclusive | translateEnum : Bool }}
                </div>

                <div class="cell-row" *ngIf="row.retailerIds?.length">
                  {{
                  'cards.products.product_status_edit.label.except'
                  | translate }}:

                  <div class="comma-delimited-list">
                    <span *ngFor="let retailerId of row.retailerIds">
                      {{ retailChainsById[retailerId]?.name }}
                    </span>
                  </div>
                </div>
              </div> -->
            </mat-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef="columns"
          ></mat-header-row>
          <mat-row
            class="assortment-table-row"
            [class.table-row-hover]="canEdit && row?.isEditable"
            [class.current]="row?.isCurrent"
            [class.upcoming]="row?.isEditable"
            [class.expired]="!row.isCurrent && !row.isEditable"
            *matRowDef="let row; columns: columns;"
            (click)="openBaseSchemaDialog(row)"
          ></mat-row>
        </mat-table>
      </div>
    </div>
  </div>
</card-expanding>
